import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=48ef07e5&scoped=true&"
import script from "./Media.vue?vue&type=script&lang=js&"
export * from "./Media.vue?vue&type=script&lang=js&"
import style0 from "./Media.vue?vue&type=style&index=0&id=48ef07e5&scoped=true&lang=scss&"
import style1 from "./Media.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ef07e5",
  null
  
)

export default component.exports